import React from 'react'
import Switch from 'react-bootstrap-switch'
import { useStateValue } from '@State'
import { ReviewContentBox } from '../../components'

export function ReviewContentLayout() {
  const [state, dispatch] = useStateValue()

  const chosenChapterIds = new Set(state.badgeInfo.selectedChapters.map(c => c))
  const chosenVideoIds = new Set(state.badgeInfo.selectedVideos.map(v => v))

  const filteredChapters = state.chapters.chapterChoices.filter(c =>
    chosenChapterIds.has(c.id)
  )
  const filteredVideos = state.videos.videoChoices.filter(v => chosenVideoIds.has(v.id))
  const filteredAssessments = state.badgeInfo.selectedAssessments.map(
    element => state.assessments[element]
  )

  const toggleBadgePrereqs = () => {
    dispatch({
      type: 'UPDATE_BADGE_INFO',
      badgeInfo: { requireNewPrereqs: !state.badgeInfo.requireNewPrereqs },
    })
  }

  return (
    <div id="outer_requirements">
      <ReviewContentBox
        title="Required Assessments"
        subtitle={`Students must pass the following assessments with a score of at least ${state.badgeInfo.passingScore}%:`}
      >
        {filteredAssessments.map((a, id) => {
          return <div key={id}>{a}</div>
        })}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Reading"
        subtitle="Students must complete the following reading:"
      >
        {filteredChapters.map(c => (
          <div key={c.id}>{c.title}</div>
        ))}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Videos"
        subtitle="Students must complete the following videos:"
      >
        {filteredVideos.map(v => (
          <div key={v.id}>{v.title}</div>
        ))}
      </ReviewContentBox>
      <h3 className="review_header">Badge Description</h3>
      <div className="data_container review_content_container">
        <div>{state.badgeInfo.description}</div>
      </div>
      {state.badgeInfo.retrievedEditData ? (
        <div>
          <h3 className="review_header">Require New Prereqs if Earned</h3>
          <h5 className="review_header">
            Set to &quot;Yes&quot; to require new prerequisites retroactively
          </h5>
          <div className="data_container review_content_container">
            <Switch
              value={state.badgeInfo.requireNewPrereqs}
              onChange={toggleBadgePrereqs}
              onColor={'success'}
              offColor={'danger'}
              labelWidth={53}
              handleWidth={49}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}
